<template>
  <div>
    <TopHeader code="train" />

    <section class="container-fluid uc-bg uc-userCenter">
      <div class="container">
        <section class="uc-userCenterPanel bg-white">
          <div class="face">
            <img :src="$store.getters.user.avatar" />
          </div>
          <div class="left">
            <h3>{{ $store.getters.user.first_name }}</h3>
            <p>{{ $store.getters.user.username }}</p>
          </div>
          <div class="info">
            <router-link :to="{ name: 'ShituApprenticeLog' }">
              <div class="item">
                <h3>
                  <i class="big">{{ model.log_count }}</i>
                </h3>
                <p>日志</p>
              </div>
            </router-link>
            <img src="../../assets/images/icon-line.png" class="line" />
            <router-link :to="{ name: 'ShituApprenticeCommunication' }">
              <div class="item">
                <h3>
                  <i class="big">{{ model.communication_count }}</i>
                </h3>
                <p>师徒沟通</p>
              </div>
            </router-link>
            <img src="../../assets/images/icon-line.png" class="line" />
            <router-link :to="{ name: 'ShituApprenticeTask' }">
              <div class="item">
                <h3>
                  <i class="big">{{ model.task_count }}</i>
                </h3>
                <p>师徒任务</p>
              </div>
            </router-link>
          </div>
        </section>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-24 col-sm-6">
            <div class="g-sideMenu">
              <div class="title">徒弟</div>
              <div class="list">
                <div
                  v-for="(item, index) in leftMenuList"
                  :key="index"
                  class="item"
                  :class="path.startsWith(item.path, 0) ? 'on' : ''"
                  @click="path = item.path"
                >
                  <router-link :to="item.path" v-html="item.name"></router-link>
                </div>
              </div>
            </div>
          </div>

          <div class="col-24 col-sm-18 uc-pl20">
            <router-view />
          </div>
        </div>
      </div>
    </section>

    <BottomFooter />
  </div>
</template>

<script>
import TopHeader from '@/components/TopHeader.vue';
import BottomFooter from '@/components/BottomFooter.vue';

export default {
  name: 'ShituApprenticeLayout',
  components: {
    TopHeader,
    BottomFooter,
  },
  data() {
    return {
      model: {},
      leftMenuList: [
        { name: '我的日志', path: '/shitu/apprentice/log' },
        { name: '师徒沟通', path: '/shitu/apprentice/communication' },
        { name: '我的任务', path: '/shitu/apprentice/task' },
        { name: '我的师傅', path: '/shitu/apprentice/master' },
      ],
      path: this.$route.path.toLowerCase(),
    };
  },
  watch: {
    $route(to, from) {
      // 对路由变化作出响应...
      this.path = to.path.toLowerCase();
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.getShituRelation();
    },
    async getShituRelation() {
      const response = await this.$api.shitu.getShituRelation({ type: 0 });
      if (response.data.code === 200) {
        this.getApprenticeStatistics();
      } else if (response.data.code === 404) {
        this.$message.warning({
          duration: 1200,
          message: `您没有权限进入徒弟页面，请重新选择身份！`,
          onClose: () => {
            // 此处写提示关闭后需要执行的函数
            this.$router.push({ name: 'Shitu' });
          },
        });
      } else {
        this.$message.warning(response.data.message);
      }
    },
    async getApprenticeStatistics() {
      const response = await this.$api.shitu.getApprenticeStatistics();
      this.model = response.data.data;
    },
  },
};
</script>
